import React from 'react';
import { Checkbox, Form, FormInstance, Input, Select } from 'antd';
import { CustomFieldDto, CustomFieldEnum } from '@common-types';
const { TextArea } = Input;
const CheckboxGroup = Checkbox.Group;
const { Option } = Select;

import './style.scss';
import { NULL_VALUE } from '@constants';
import { FormattedMessage } from 'react-intl';

const CustomFieldsCard = ({
  formInstance,
  customFields
}: any) => {

  // const handleChange = (key: string) => (value: any) => {
  //   handleCustomInputChange({ key: key, value: JSON.stringify(value) })
  // }

  return (
    <div className="card shadow custom-fields">
      <div className="card-header border-bottom p-4">
        <h4 className="card-title mb-0">
          <i className="bi bi-card-text me-2"></i><FormattedMessage id="additional.fields" />
        </h4>
      </div>

      <div className="card-body p-4">
        <Form
          form={NULL_VALUE}
          ref={formInstance}
          autoComplete="off"
          layout="vertical"
        >

          {customFields.map((customField: CustomFieldDto, index: any) => (
            <div className="row g-3 pt-3" key={index}>
              <div className="col-8">
                {
                  CustomFieldEnum[customField.type] == CustomFieldEnum.SingleText.toString()
                    ?
                    <Form.Item
                      label={<label className="form-label"><span className="h6 fw-normal">{customField.label} {`${customField.mandatory ? '*' : ''}`}</span></label>}
                      tooltip={customField.helpText}
                      name={customField.id.toString()}
                      validateTrigger="onBlur"
                      rules={[
                        { required: customField.mandatory, validateTrigger: 'onBlur', message: 'This field is required.' },
                        { min: customField.minimum || undefined, message: `Value must be greater than ${customField.minimum} characters` },
                        { max: customField.maximum || undefined, message: `Value should be less than ${customField.maximum} characters.` },
                      ]}
                    >
                      <Input
                        id='customField'
                        name={customField.id.toString()}
                        //onChange={handleInputChange}
                        //onBlur={handleBlur}
                        //minLength={customField.minimum || undefined}
                        //maxLength={customField.maximum || undefined}
                        placeholder={customField.label}
                        className='form-control form-control-lg'
                      />
                    </Form.Item>
                    : null
                }
                {
                  CustomFieldEnum[customField.type] == CustomFieldEnum.LongText.toString()
                    ?
                    <Form.Item
                      label={<label className="form-label"><span className="h6 fw-normal">{customField.label} {`${customField.mandatory ? '*' : ''}`}</span></label>}
                      tooltip={customField.helpText}
                      name={customField.id.toString()}
                      validateTrigger="onBlur"
                      rules={[
                        { required: customField.mandatory, validateTrigger: 'onBlur', message: 'This field is required.' },
                        { min: customField.minimum || undefined, message: `Value must be greater than ${customField.minimum} characters` },
                        { max: customField.maximum || undefined, message: `Value should be less than ${customField.maximum} characters.` },
                      ]}
                    >
                      <TextArea
                        id='customField'
                        name={customField.id.toString()}
                        //onChange={handleInputChange}
                        //onBlur={handleBlur}
                        rows={5}
                        //maxLength={customField.maximum || undefined}
                        placeholder={customField.label}
                        className='form-control form-control-lg' />
                    </Form.Item>
                    : null
                }

                {
                  CustomFieldEnum[customField.type] == CustomFieldEnum.Dropdown.toString()
                    ?
                    <Form.Item
                      label={<label className="form-label"><span className="h6 fw-normal">{customField.label} {`${customField.mandatory ? '*' : ''}`}</span></label>}
                      tooltip={customField.helpText}
                      name={customField.id.toString()}
                      validateTrigger="onBlur"
                      rules={[
                        { required: customField.mandatory, message: 'This field is required.' },
                        //{ min: customField.minimum || undefined, message: <div className="text-danger">{`Value must be greater than ${customField.minimum} characters`}</div> },
                        //{ max: customField.multiSelect && customField.maximum || undefined, message: <div className="text-danger">{`Value should be less than ${customField.maximum} characters.`}</div> },
                      ]}
                    >
                      {customField.multiSelect ?
                        <Select
                          //onChange={handleChange(customField.id.toString())}
                          //onBlur={handleBlur}
                          placeholder={customField.label}
                          mode='multiple'
                          className='customSelect'
                        >
                          {customField.options?.map((option: any, index: number) => (<Option key={index} value={option}>{option}</Option>))}
                        </Select>
                        :
                        <Select
                          //onChange={handleChange(customField.id.toString())}
                          //onBlur={handleBlur}
                          placeholder={customField.label}
                          className='customSelect'
                        >
                          {customField.options?.map((option: any, index: number) => (<Option key={index} value={option}>{option}</Option>))}
                        </Select>
                      }
                    </Form.Item>
                    : null
                }

                {
                  CustomFieldEnum[customField.type] == CustomFieldEnum.Checkbox.toString()
                    ?
                    <Form.Item
                      label={<label className="form-label"><span className="h6 fw-normal">{customField.label} {`${customField.mandatory ? '*' : ''}`}</span></label>}
                      tooltip={customField.helpText}
                      name={customField.id.toString()}
                      rules={[
                        { required: customField.mandatory, message: 'This field is required.' },
                        //{ max: customField.maximum ? customField.maximum : undefined, message: <div className="text-danger">{`Value should be less than ${customField.maximum} characters.`}</div> },
                      ]}
                    >
                      <CheckboxGroup
                        //onChange={handleChange(customField.id.toString())}
                        name={customField.id.toString()}
                        options={customField.options}
                      />
                    </Form.Item>
                    : null
                }
              </div>
            </div>
          ))}

        </Form>

      </div>
    </div>
  );
};

export default CustomFieldsCard;
